import Vue from 'vue'

const luPosition = {
state: {
luPositions: [],
selectedLuPosition: {},
saving: false,
searchCount: 0,
},

getters: {
luPositions(state) {
return state.luPositions
},
selectedLuPosition(state) {
return state.selectedLuPosition
},
loading(state) {
return state.searchCount > 0
},
},

mutations: {
luPositions(state, payload) {
state.luPositions = payload
},
selectedLuPosition(state, payload) {
state.selectedLuPosition = JSON.parse(JSON.stringify(payload))
},
saving(state, payload) {
state.saving = payload
},
searchCount(state, payload) {
state.searchCount = payload
},
increaseSearchCount(state, payload) {
state.searchCount = state.searchCount + 1
},
decreaseSearchCount(state, payload) {
state.searchCount = state.searchCount - 1
},
},

actions: {
setSelectedLuPosition(context, payload) {
context.commit('selectedLuPosition', payload)
},
loadLuPositions(context, payload) {
return new Promise((resolve, reject) => {
const url = 'LuPosition'
context.commit('increaseSearchCount')
Vue.prototype.$axios
.get(url)
.then(
(res) => {
context.commit('luPositions', res.data)
context.commit('decreaseSearchCount')
resolve(res)
},
(err) => {
console.error(err)
context.commit('decreaseSearchCount')
context.dispatch('errors/handleError', err, { root: true })
reject(err)
},
)
})
},
refreshSelectedLuPosition(context, payload) {
if (context.state.selectedLuPosition && context.state.selectedLuPosition.ID)
{
context.dispatch('loadSelectedLuPosition',
context.state.selectedLuPosition.ID)
}
},
loadSelectedLuPosition(context, payload) {
if (context.state.selectedLuPosition && context.state.selectedLuPosition.ID
!= payload) {
context.commit('selectedLuPosition', {})
}
return new Promise((resolve, reject) => {
const url = 'LuPosition/' + payload
Vue.prototype.$axios
.get(url)
.then(
(res) => {
context.commit('selectedLuPosition', res.data)
resolve(res)
},
(err) => {
console.error(err)
context.dispatch('errors/handleError', err, { root: true })
reject(err)
},
)
})
},
clearLookupCacheAndReloadLuPositions(context, payload) {
caches.delete('apilookup-cache').finally(() => {
context.dispatch('loadLuPositions')
}, )
},
updateLuPosition(context, payload){
return new Promise((resolve, reject) => {
const url = `LuPosition/${ payload.ID }`
context.commit('saving', true)
Vue.prototype.$axios
.put(url, payload)
.then(
(res) => {
context.dispatch('messages/toastMessage',
{color: 'success', message: 'position updated',},{ root: true })
//if you will always need to reload the list after an update
//you can uncomment out the following dispatch line.
//Alternatively you can reload whatever object you need
//when the promise resolves in the component that called it.
//context.dispatch('loadLuPositions')
context.commit('saving', false)
resolve(res)
},
(err) => {
console.error(err)
context.commit('saving', false)
context.dispatch('errors/handleError', err, { root: true })
reject(err)
},
)
})
},
createLuPosition(context, payload){
return new Promise((resolve, reject) => {
const url = `LuPosition`
context.commit('saving', true)
Vue.prototype.$axios
.post(url, payload)
.then(
(res) => {
context.dispatch('messages/toastMessage',
{color: 'success', message: 'position created',},{ root: true })
//if you will always need to reload the list after an item is created
//you can uncomment out the following dispatch line.
//Alternatively you can reload whatever object you need
//when the promise resolves in the component that called it.
//context.dispatch('loadLuPositions')
context.commit('saving', false)
resolve(res)
},
(err) => {
console.error(err)
context.commit('saving', false)
context.dispatch('errors/handleError', err, { root: true })
reject(err)
},
)
})
},
saveLuPosition(context, payload){
return new Promise((resolve, reject) => {
if (payload.ID > 0) {
context.dispatch('updateLuPosition', payload)
.then((res) => resolve(res), (err) => reject(err))
} else {
context.dispatch('createLuPosition', payload)
.then((res) => resolve(res), (err) => reject(err))
}
})
},
deleteLuPosition(context, payload){
return new Promise((resolve, reject) => {
const url = `LuPosition/${ payload.ID }`
Vue.prototype.$axios
.delete(url)
.then(
(res) => {
context.dispatch('messages/toastMessage',
{color: 'success', message: 'position deleted',},{ root: true })
//if you will always need to reload the list after a delete
//you can uncomment out the following dispatch line.
//Alternatively you can reload whatever object you need
//when the promise resolves in the component that called it.
//context.dispatch('loadLuPositions')
resolve(res)
},
(err) => {
console.error(err)
context.dispatch('errors/handleError', err, { root: true })
reject(err)
},
)
})
},
},
}

export default luPosition